'use client';

import Text from '@commons/components/Text';
import { BaseContainer, type BaseContainerProps } from '@commons/containers/BaseContainer';
import { usePageContext } from '@commons/contexts/page';

// Type definition for the PlaceholderBlock component properties.

type Props = BaseContainerProps & {
  placeholder?: string;
};

/**
 * PlaceholderBlock component.
 *
 * Renders a placeholder block in the editor or returns null otherwise.
 */

const PlaceholderBlock = ({ children, placeholder, ...props }: Props) => {
  const { isEditing } = usePageContext();

  if (isEditing) {
    return (
      <BaseContainer width={12} padding="xs" border="all" {...props}>
        <Text marginBottom="none">{placeholder}</Text>
      </BaseContainer>
    );
  }

  return children;
};

export default PlaceholderBlock;
